import React, { memo, useEffect, useRef, useState } from 'react';
import { createWidget } from '@typeform/embed';
import getIdFromUrl from './getIdFromEmbedUrl';
import debounce from '../../../utils/debounce';
import '@typeform/embed/build/css/widget.css';

/** @param {FF.ContentfulTypeform} props */
function Widget({ formEmbedUrl }) {
  /**  @type {React.MutableRefObject<HTMLDivElement|null>} errorMsgRef */
  const container = useRef(null);
  const [widgetHeight, setWidgetHeight] = useState(500);

  useEffect(() => {
    if (container.current) {
      const ref = createWidget(getIdFromUrl(formEmbedUrl), {
        container: container.current,
        lazy: true,

        onHeightChanged: debounce(
          /**
           * @param {object} heightChangedEvent
           * @param {number} heightChangedEvent.height
           */ ({ height }) => {
            setWidgetHeight(height);
          },
        ),
      });
      const formHeightChangeHandler = debounce(
        /**
         * @param {MessageEvent} event
         */ event => {
          if (
            event.origin === 'https://form.typeform.com' &&
            event.data?.type === 'form-height-changed'
          ) {
            setWidgetHeight(event.data.height);
          }
        },
      );

      window.addEventListener('message', formHeightChangeHandler);

      return () => {
        ref.unmount();
        window.removeEventListener('message', formHeightChangeHandler);
      };
    }
    return () => {};
  }, []);

  return (
    <div
      ref={container}
      style={{ height: `${widgetHeight || 500}px`, minHeight: `500px` }}
    />
  );
}

export default memo(Widget);
